export default "__VITE_ASSET__CFD2lvRu__"